
import { defineComponent, ref } from 'vue'
import PreviewImage
  from '@/views/dashboard/data-safe/screen-watermark-edit/_components/watermark-preview/preview-image.vue'
import WatermarkZoom
  from '@/views/dashboard/data-safe/screen-watermark-edit/_components/watermark-preview/watermark-zoom.vue'
import { PropType } from 'vue/dist/vue'
import { Wmdata } from '@/views/dashboard/data-safe/screen-watermark/screen-watermark.service'

export default defineComponent({
  components: {
    WatermarkZoom,
    PreviewImage
  },

  props: {
    wmdata: {
      type: Object as PropType<Wmdata>,
      default: () => ({}),
    },
  },

  setup (props, context) {
    const watermarkZoomVisible = ref(false)

    return {
      watermarkZoomVisible,
    }
  }
})
